import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Phuluc5table = React.memo(function Phuluc5table(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th} style={{ width: "15vw" }}>
            Chỉ tiêu
          </th>
          <th className={classes.tablebc_th}>Thực hiện tháng trước</th>
          <th className={classes.tablebc_th}>Dự tính tháng báo cáo</th>
          <th className={classes.tablebc_th}>
            Cộng dồn đến cuối tháng báo cáo
          </th>
          <th className={classes.tablebc_th}>
            Dự tính tháng báo cáo so với tháng trước (%)
          </th>
          <th className={classes.tablebc_th}>
            Dự tính tháng báo cáo so cùng kỳ (%)
          </th>
          <th className={classes.tablebc_th}>
            Cộng dồn đến cuối tháng báo cáo so cùng kỳ (%)
          </th>
        </tr>
        <tr>
          <th className={classes.tablebc_th}>A</th>
          <th className={classes.tablebc_th}>1</th>
          <th className={classes.tablebc_th}>2</th>
          <th className={classes.tablebc_th}>3</th>
          <th className={classes.tablebc_th}>4=2/1*100</th>
          <th className={classes.tablebc_th}>5</th>
          <th className={classes.tablebc_th}>6</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["chitieu"]}</td>
              <td className={classes.tablesotan_td}>
                {row["thuchien_thangtruoc"]}
              </td>
              <td className={classes.tablesotan_td}>
                {row["thuchien_thangnay"]}
              </td>
              <td className={classes.tablesotan_td}>{row["thuchien_luyke"]}</td>
              <td className={classes.tablesotan_td}>
                {row["tyle_sothangtruoc"]}
              </td>
              <td className={classes.tablesotan_td}>{row["tyle_socungky"]}</td>
              <td className={classes.tablesotan_td}>{row["tyle_luyke"]}</td>
            </tr>
          );
        })}
        <tr>
          <td className={classes.tablesotan_td}>
            C. TỔNG SẢN LƯỢNG HÀNG HÓA THÔNG QUA CẢNG - Nghìn TTQ
          </td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
          <td className={classes.tablesotan_td}></td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Phuluc5table.propTypes = {
  data: PropTypes.array,
};
export default Phuluc5table;
